const querystring = new URLSearchParams(window.location.search);
export function queryStringOrSessionStorage(key: string): string | null {
  if(querystring.has(key)) {
    const value = querystring.get(key)!;
    sessionStorage.setItem(key, value);
    return value;
  } else {
    const value = sessionStorage.getItem(key);
    return value;
  }
}